/* global process */
import 'whatwg-fetch';

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response
  }

  return response;
}

const parseJSON = r => r.json().then(data => ({
  authorization: r.headers.get('x-authorization'),
  data
}))

const getCookie = (name) => {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

const request = (url, options, cb) => {
  fetch(url, {
    headers: {
      'Ocp-Apim-Subscription-Key': process.env.CLIENT_TOKEN,
      Authorization: `Bearer ${window.xpSession ? window.xpSession.token : getCookie('XPUSERTOKEN')}`,
    },
    ...options,
  })
  .then(checkStatus)
  .then(parseJSON)
  .then((data) => {
    cb(data);
  })
}

export default request;
